import clsx from 'clsx';
import type { LabelHTMLAttributes, ReactNode } from 'react';

export function Label({ className, children, ...rest }: LabelHTMLAttributes<HTMLLabelElement> & { children: ReactNode }) {
  return (
    <label className={clsx('block text-sm font-medium text-content mb-1.5', className)} {...rest}>
      {children}
    </label>
  );
}
